import * as React from 'react'
import * as Bowser from 'bowser'

import { Text } from '@espoon-voltti/react-components/elements'

import { t } from '../../i18n'

const browser = Bowser.getParser(window.navigator.userAgent)
const isValidBrowser = browser.satisfies({
  chrome: '>=83',
  firefox: '>=78'
})

export const BrowserSupport: React.FC = () =>
  isValidBrowser ? null : (
    <div>
      <Text align={'centered'} weight={'bold'} display={'block'}>
        {t(['views', 'landing', 'browserSupport', 'unsupportedBrowser'])}
      </Text>
      <Text align={'centered'}>
        {t(['views', 'landing', 'browserSupport', 'info'])}
      </Text>
    </div>
  )
